import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"
import Products from "./Products/Products"
import KeywordsTable from "./KeywordsTable/KeywordsTable"

const AddKeywordsAndBidsModal = ({ isModalOpen, setIsModalOpen }) => {

  const toggle = () => setIsModalOpen(!isModalOpen)

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <div className="fw-semibold fs-4">Add Keywords and Bid</div>


          <Row>
            <Col xs='4'>
              <Products />
            </Col>
            <Col>
              <KeywordsTable />
            </Col>
          </Row>
          

          {/* <div className="d-flex justify-content-end mt-3">
            <div className="d-flex gap-2 fw-medium">
              <div className="border border-dark rounded rounded-3 px-2 py-1 cursor-pointer" onClick={toggle}>Cancel</div>
            </div>
          </div> */}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AddKeywordsAndBidsModal
